function inputCheck() {
  //  console.time('exec-time');

  // 画面サイズでデバイス判定
  let isMobile = false;
  if (window.matchMedia && window.matchMedia('(max-device-width: 749px)').matches) {
    isMobile = true;
  }

  // 絞り込みのチェックボックスを全て取得
  // ※画面で表示、使用されている要素のみに限定
  let checkboxes = document.querySelectorAll('facet-filters-form input[type=checkbox]')
  let realCheckboxes = Array.from(checkboxes).filter(function(checkbox) {
    let id = checkbox.id;
    if (isMobile) {
      return id && id.includes('-mobile');
    } else {
      return id && !id.endsWith('-no-js') && !id.includes('-mobile');
    }
  });

  // 有効なチェックボックスのdisabled解除
  let sameCategoryGroup = [];
  for (let i = 0; i < realCheckboxes.length; i++) {
    if (realCheckboxes[i].parentElement.classList.contains('facet-checkbox--disabled') === false && realCheckboxes[i].parentElement.classList.contains('mobile-facets__label--disabled') === false && realCheckboxes[i].dataset.vct != 0) {
      realCheckboxes[i].removeAttribute('disabled');
    }

    if (sameCategoryGroup[realCheckboxes[i].name] === undefined) {
      sameCategoryGroup[realCheckboxes[i].name] = [];
    }
    sameCategoryGroup[realCheckboxes[i].name].push(realCheckboxes[i]);
  }

  // 絞り込みカテゴリーごとに処理
  for (let name in sameCategoryGroup) {
    let category = sameCategoryGroup[name];

    // カテゴリー内のチェック状況をチェック
    let uncheckedCount = 0;
    let checkedId = '';
    for (let x = 0; x < category.length; x++) {
      if (category[x].checked === false) {
        uncheckedCount += 1;
      } else {
        checkedId = category[x].id;
      }
    }

    // カテゴリー内全てが未チェックの場合、親のdisabledを解除
    if (uncheckedCount == category.length) {
      for (let y = 0; y < category.length; y++) {
        if (category[y].checked == false && category[y].dataset.vct != 0) {
          if (category[y].parentElement.classList.contains('mobile-facets__label--disabled') === true) {
            category[y].parentElement.classList.remove('mobile-facets__label--disabled');
          } else if (category[y].parentElement.classList.contains('facet-checkbox--disabled') === true) {
            category[y].parentElement.classList.remove('facet-checkbox--disabled');
          }
        }
      }
    } else {
      // カテゴリー内でいずれかチェックの場合、チェックされていない要素をdisabled
      for (let z = 0; z < category.length; z++) {
        if (category[z].id !== checkedId) {
          category[z].setAttribute('disabled', 'disabled');
          if (category[z].parentElement.classList.contains('mobile-facets__label') === true) {
            category[z].parentElement.classList.add('mobile-facets__label--disabled');
          } else {
            category[z].parentElement.classList.add('facet-checkbox--disabled');
          }
        }
      }
    }
  }
  //  console.timeEnd('exec-time')
}

// 100ミリ秒間隔で処理を実施
setInterval(() => {
  inputCheck();
}, 100);
